import http from "./http";
import { API_URL, USE_MOCK } from "./config";
import { listResource } from "./resource";
import { RESOURCES } from "../pages/Resource/resources";

// Options for relation fields (agent, bank account, party ...): the lookup
// resource's rows, fetched once per slug and cached.
const cache = {};

export const optionLabel = (slug, row) => {
  const resource = RESOURCES[slug];
  return resource?.optionLabel?.(row) ?? row.name ?? row.title ?? String(row.id);
};

export function getLookup(slug) {
  if (!cache[slug]) {
    cache[slug] = listResource(RESOURCES[slug], { page: 1, limit: 1000 })
      .then(({ data }) => data)
      .catch((error) => {
        delete cache[slug]; // retry next time instead of caching a failure
        throw error;
      });
  }
  return cache[slug];
}

// Created/edited rows change what the dropdowns should offer
export const clearLookupCache = (slug) => {
  if (slug) delete cache[slug];
  else Object.keys(cache).forEach((key) => delete cache[key]);
};

// Role form: permission checkboxes grouped by module -> [{ module, policies: [{ name, children: [{ id, name }] }] }]
export async function getPolicyGroups() {
  if (USE_MOCK) {
    return ["Order", "Setting", "Accounts"].map((module, m) => ({
      module,
      policies: ["Order", "Report"].slice(0, m === 1 ? 1 : 2).map((name, p) => ({
        name: `${module} ${name}`,
        children: ["View", "Create", "Edit", "Delete"].map((action, a) => ({
          id: m * 100 + p * 10 + a + 1,
          name: `${action} ${module} ${name}`,
        })),
      })),
    }));
  }

  const { data } = await http.get(`${API_URL}policies/group-by`);
  return data.payload || [];
}
